import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useHistoryEntryState = <T>(key: string) => {
	const { key: locationKey } = useLocation();
	const storageKey = `${key}:${locationKey}`;

	const saved = useMemo<T | undefined>(() => {
		try {
			const stored = sessionStorage.getItem(storageKey);
			return stored ? JSON.parse(stored) : undefined;
		} catch {
			return undefined;
		}
	}, [storageKey]);

	const save = (value: T) => {
		try {
			sessionStorage.setItem(storageKey, JSON.stringify(value));
		} catch {}
	};

	return { saved, save };
};
